module.exports = __webpack_public_path__ + "static/img/add_order.8178b478.png";